import { render, staticRenderFns } from "./ProductionQualityInspectionVisualDetailUpload.vue?vue&type=template&id=8906d04a&"
import script from "./ProductionQualityInspectionVisualDetailUpload.vue?vue&type=script&lang=js&"
export * from "./ProductionQualityInspectionVisualDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports